import { INotificationViewModel } from 'viewModels';
import api from '../services/api/axios';

const getByUserId = (userId: string, pageParam: number, take: number): Promise<INotificationViewModel[]> =>
  new Promise<INotificationViewModel[]>((resolve, reject) => {
    api
      .get(`notification/get-by-user/${userId}`, {
        params: {
          page: pageParam,
          take
        }
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });

const markAsRead = (id: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .put(`notification/mark-as-read/${id}`)
      .then(() => resolve())
      .catch(reject);
  });

const markAllAsRead = (userId: string) =>
  new Promise<void>((resolve, reject) => {
    api
      .put(`notification/mark-all-as-read/${userId}`)
      .then(() => resolve())
      .catch(reject);
  });

export const NotificationController = {
  getByUserId,
  markAllAsRead,
  markAsRead,
};
